import dayjs from "dayjs"
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";

interface IProps {
    title: string
    issuedWellnessTicketList: IIssuedWellnessTicketByMemberIdAndWellnessLectureIdResponseV2[]
    selectedId?: number
    setSelectedId: Function
}
const TICKET_LIST_MAX_HEIGHT = 160;

const MyIssuedWellnessTicketAvaiable = ({ title, issuedWellnessTicketList, selectedId, setSelectedId }: IProps) => {

    return <>
        <div className="sub-title/st3" style={{ paddingBlock: 6, marginBottom: 8 }}>{title}</div>
        <div style={{ maxHeight: TICKET_LIST_MAX_HEIGHT, overflowY: 'auto' }}>
            {issuedWellnessTicketList.map(issuedWellnessTicket =>
                <Flex
                    key={issuedWellnessTicket.issuedWellnessTicketId}
                    onClick={() => issuedWellnessTicket.issuedWellnessTicketIsUsableDate && setSelectedId(issuedWellnessTicket.issuedWellnessTicketId)}
                    gap={8}
                    style={{ padding: '6px 12px', backgroundColor: 'var(--secondarys100)', marginBottom: 8, alignItems: 'center', cursor: 'pointer' }}
                >
                    {(selectedId === issuedWellnessTicket.issuedWellnessTicketId && issuedWellnessTicket.issuedWellnessTicketIsUsableDate)
                        ? <CheckCircleFilled style={{ fontSize: '20px', flexShrink: 0 }} />
                        : <CheckCircleOutlined style={{ fontSize: '20px', color: '#AFAFAF', flexShrink: 0 }} />
                    }
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div
                            className="body/b2"
                            style={{ fontWeight: issuedWellnessTicket.issuedWellnessTicketIsUsableDate ? "700" : "400", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        >{issuedWellnessTicket.issuedWellnessTicketName}</div>
                        <div className="body/b2 secondary/s700" style={{ marginTop: 2 }}>
                            <span className="base/black">{issuedWellnessTicket.issuedWellnessTicketRemainingCnt}회 남음</span>
                            {` · ${issuedWellnessTicket.issuedWellnessTicketIsUsableDate ? dayjs(issuedWellnessTicket.issuedWellnessTicketExpireDate).format("YYYY.MM.DD.") + "까지" : "사용 불가 날짜"}`}
                            {issuedWellnessTicket.issuedWellnessTicketIsGuestAvailable && ' · 동반 가능'}
                        </div>
                    </div>
                </Flex>
            )}
        </div>
    </>

}

export { MyIssuedWellnessTicketAvaiable }
